import { appLanguage } from '@orientaction/reducers';
import { useSelector } from 'react-redux';
import Page00 from '../../../../Book/EbookEtape_3/Page/00';
import Page01 from '../../../../Book/EbookEtape_3/Page/01';
import Page02 from '../../../../Book/EbookEtape_3/Page/02';
import Page03 from '../../../../Book/EbookEtape_3/Page/03';
import Page04 from '../../../../Book/EbookEtape_3/Page/04';
import Page05 from '../../../../Book/EbookEtape_3/Page/05';
import Page06 from '../../../../Book/EbookEtape_3/Page/06';
import Page07 from '../../../../Book/EbookEtape_3/Page/07';
import Page08 from '../../../../Book/EbookEtape_3/Page/08';
import Page09 from '../../../../Book/EbookEtape_3/Page/09';
import Page10 from '../../../../Book/EbookEtape_3/Page/10';
import Page11 from '../../../../Book/EbookEtape_3/Page/11';
import Page12 from '../../../../Book/EbookEtape_3/Page/12';
import Page13 from '../../../../Book/EbookEtape_3/Page/13';
import Page14 from '../../../../Book/EbookEtape_3/Page/14';
import Page15 from '../../../../Book/EbookEtape_3/Page/15';
import Page16 from '../../../../Book/EbookEtape_3/Page/16';
import Page17 from '../../../../Book/EbookEtape_3/Page/17';
import Page18 from '../../../../Book/EbookEtape_3/Page/18';
import Page19 from '../../../../Book/EbookEtape_3/Page/19';
import Page20 from '../../../../Book/EbookEtape_3/Page/20';
import Page21 from '../../../../Book/EbookEtape_3/Page/21';
import Page22 from '../../../../Book/EbookEtape_3/Page/22';
import Page22a from '../../../../Book/EbookEtape_3/Page/22a';
import Page23 from '../../../../Book/EbookEtape_3/Page/23';
import Page24 from '../../../../Book/EbookEtape_3/Page/24';
import Page25 from '../../../../Book/EbookEtape_3/Page/25';
import Page26 from '../../../../Book/EbookEtape_3/Page/26';
import Page27 from '../../../../Book/EbookEtape_3/Page/27';
import Page28 from '../../../../Book/EbookEtape_3/Page/28';
import Page29 from '../../../../Book/EbookEtape_3/Page/29';
import Page30 from '../../../../Book/EbookEtape_3/Page/30';
import Page31 from '../../../../Book/EbookEtape_3/Page/31';
import Page32 from '../../../../Book/EbookEtape_3/Page/32';
import Page33 from '../../../../Book/EbookEtape_3/Page/33';
import Page33a from '../../../../Book/EbookEtape_3/Page/33a';
import Page34 from '../../../../Book/EbookEtape_3/Page/34';
import Page35 from '../../../../Book/EbookEtape_3/Page/35';
import Page36 from '../../../../Book/EbookEtape_3/Page/36';
import Page37 from '../../../../Book/EbookEtape_3/Page/37';
import Page37a from '../../../../Book/EbookEtape_3/Page/37a';
import Page38 from '../../../../Book/EbookEtape_3/Page/38';
import Page39 from '../../../../Book/EbookEtape_3/Page/39';
import Page40 from '../../../../Book/EbookEtape_3/Page/40';
import Page41 from '../../../../Book/EbookEtape_3/Page/41';
import Page42 from '../../../../Book/EbookEtape_3/Page/42';
import Page43 from '../../../../Book/EbookEtape_3/Page/43';

type StepContentProps = {
  readOnly: boolean;
};

const Step3Content = ({ readOnly }: StepContentProps) => {
  const lang: string = useSelector(appLanguage);

  return (
    <>
      <Page00 />
      <Page01 />
      <Page02 />
      <Page03 />
      <Page04 readOnly={readOnly} />
      <Page05 />
      <Page06 />
      <Page07 />
      <Page08 />
      <Page09 />
      <Page10 />
      <Page11 />
      <Page12 />
      <Page13 />
      <Page14 />
      <Page15 />
      <Page16 />
      <Page17 />
      <Page18 />
      <Page19 />
      <Page20 />
      <Page21 />
      <Page22 />
      {lang !== 'GB' && <Page22a />}
      <Page23 />
      <Page24 />
      <Page25 />
      <Page26 />
      <Page27 />
      <Page28 />
      <Page29 />
      <Page30 />
      <Page31 />
      <Page32 />
      <Page33 />
      {lang !== 'GB' && <Page33a />}
      <Page34 readOnly={readOnly} />
      <Page35 readOnly={readOnly} />
      <Page36 />
      <Page37 />
      {lang !== 'GB' && <Page37a />}
      <Page38 />
      <Page39 />
      <Page40 />
      <Page41 />
      <Page42 />
      <Page43 />
    </>
  );
};

export default Step3Content;
